import React from "react";
import PropTypes from "prop-types";
import COLORS from "../../utils/constants";

const LegendBubble = ({ bubbleScale }) => {
  /**
   * To create our bubble scale we produce 3 bubbles. Each bubble represents a factor of 10.
   * To get our largest bubble, we round down to the next factor of 10 from the max value in the scale's
   * domain.
   *
   * Eg. if the maxVal is 14,530 our largest bubble will be set to 10,000. Our medium bubble will be 1,000
   * and our small bubble will be 100.
   *
   * If the maxVal is less than 1,000, we default the largest bubble to 100. This is so that our medium and
   * small bubbles don't turn out wacky.
   */
  const smallVal = 10;
  const medVal = 20;
  const largeVal = 60;
  const small = bubbleScale(smallVal);
  const med = bubbleScale(medVal);
  const large = bubbleScale(largeVal);
  return (
    <div className="leaflet-map__legend-bubble-container">
      <span className="leaflet-map__legend-bubble-label">{smallVal}%</span>
      <BubbleDiv r={small} color={COLORS.markers} />
      <BubbleDiv r={med} color={COLORS.markers} />
      <BubbleDiv r={large} color={COLORS.markers} />
      <span className="leaflet-map__legend-bubble-label">{largeVal}%</span>
    </div>
  );
};

LegendBubble.propTypes = {
  bubbleScale: PropTypes.func.isRequired,
};

const BubbleDiv = ({ r, color }) => {
  const height = r * 2; // multiply by 2 to get circumfrence
  const style = {
    height,
    width: height,
    borderRadius: "50%",
    display: "inline-block",
    backgroundColor: color,
    margin: "0 3px",
  };
  return <div style={style} className="leaflet-map__legend-bubble" />;
};

BubbleDiv.propTypes = {
  r: PropTypes.number.isRequired,
  color: PropTypes.string.isRequired,
};

export default LegendBubble;
